import Vue from 'vue';
import axios from 'axios';
import VueScrollTo from 'vue-scrollto';

var script = Vue.extend({
    props: {
        size: Number,
        color: String
    },
    computed: {
        borderWidth: function () {
            return this.size < 64 ? 3 : 6;
        },
        styles: function () {
            return {
                'width': this.size + "px",
                'height': this.size + "px",
                'border-width': this.borderWidth + "px",
                'border-color': this.color + " transparent transparent transparent"
            };
        },
        containerStyles: function () {
            return {
                width: this.size + "px",
                height: this.size + "px"
            };
        }
    }
});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-ring",style:(_vm.containerStyles)},[_c('div',{style:(_vm.styles)}),_vm._v(" "),_c('div',{style:(_vm.styles)}),_vm._v(" "),_c('div',{style:(_vm.styles)}),_vm._v(" "),_c('div',{style:(_vm.styles)})])};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = function (inject) {
    if (!inject) { return }
    inject("data-v-4e926834_0", { source: ".loader-ring[data-v-4e926834]{display:inline-block;position:relative;vertical-align:middle}.loader-ring div[data-v-4e926834]{box-sizing:border-box;display:block;position:absolute;border:6px solid #fff;border-radius:50%;animation:loader-ring-data-v-4e926834 1.2s cubic-bezier(.5,0,.5,1) infinite}.loader-ring div[data-v-4e926834]:nth-child(1){animation-delay:-.45s}.loader-ring div[data-v-4e926834]:nth-child(2){animation-delay:-.3s}.loader-ring div[data-v-4e926834]:nth-child(3){animation-delay:-.15s}@keyframes loader-ring-data-v-4e926834{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__ = "data-v-4e926834";
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

var ApiService = new Vue({
    data: function () {
        return {
            ingredients: {},
            ingredientsLoaded: false
        };
    },
    methods: {
        initialize: function () {
            var _this = this;
            axios
                .get('/api/catalog/ingredients')
                .then(function (response) { return (_this.setIngredients(response.data)); });
        },
        setIngredients: function (response) {
            this.ingredients = response;
            this.ingredientsLoaded = true;
        }
    }
});

var script$1 = Vue.extend({
    props: {
        chosenIngredient: {}
    }
});

/* script */
var __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"name":"ingredient-details","id":"ingredient-details-pointer"}}),_vm._v(" "),(_vm.chosenIngredient.name)?_c('div',{staticClass:"ingredientDetails",class:_vm.chosenIngredient.class},[_c('h2',{staticClass:"ingredient-details-header"},[_vm._v(_vm._s(_vm.chosenIngredient.name))]),_vm._v(" "),_c('p',{staticClass:"ingredient-details-origin"},[_vm._v(_vm._s(_vm.chosenIngredient.origin_normal))]),_vm._v(" "),_c('p',{staticClass:"ingredient-details-description"},[_vm._v(_vm._s(_vm.chosenIngredient.description))])]):_vm._e()])};
var __vue_staticRenderFns__$1 = [];

  /* style */
  var __vue_inject_styles__$1 = function (inject) {
    if (!inject) { return }
    inject("data-v-8605506e_0", { source: "div.ingredientDetails[data-v-8605506e]{margin:0 0 50px 0;text-align:left}h2.ingredient-details-header[data-v-8605506e]{text-transform:uppercase;font-weight:700;font-size:1.8em;margin:.4em 0 0;padding:.8em 0;border-bottom:1px solid rgba(0,0,0,.6)}p.ingredient-details-origin[data-v-8605506e]{font-size:1.2em;font-weight:400;padding:1em 0;border-bottom:1px solid rgba(0,0,0,.5);margin:0}p.ingredient-details-description[data-v-8605506e]{margin:0;font-size:1.1em;padding:1em 0;border-bottom:1px solid rgba(106,83,61,.3)}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$1 = "data-v-8605506e";
  /* module identifier */
  var __vue_module_identifier__$1 = undefined;
  /* functional template */
  var __vue_is_functional_template__$1 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$2 = Vue.extend({
    props: {
        stack: []
    },
    methods: {
        goToLetter: function (letter) {
            this.$emit('goToLetter', letter);
        }
    }
});

/* script */
var __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stack)?_c('div',{staticClass:"letters"},_vm._l((_vm.stack),function(stackElement,key){return _c('ul',{key:key,staticClass:"searchLetters"},[_c('li',{on:{"click":function($event){return _vm.goToLetter(key)}}},[_vm._v(" "+_vm._s(key))])])}),0):_vm._e()};
var __vue_staticRenderFns__$2 = [];

  /* style */
  var __vue_inject_styles__$2 = function (inject) {
    if (!inject) { return }
    inject("data-v-2521973e_0", { source: "div.letters[data-v-2521973e]{position:sticky;background-color:#fff;top:0;margin-top:20px}ul.searchLetters[data-v-2521973e]{display:inline-block;list-style:none;margin:10px 0}ul.searchLetters>li[data-v-2521973e]{font-size:1.2em;cursor:pointer;margin:0 5px}@media screen and (max-width:960px){div.letters[data-v-2521973e]{position:sticky;float:right;margin-right:-10px;top:54px;z-index:91}div.letters>ul[data-v-2521973e]{display:block}}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$2 = "data-v-2521973e";
  /* module identifier */
  var __vue_module_identifier__$2 = undefined;
  /* functional template */
  var __vue_is_functional_template__$2 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    createInjector,
    undefined,
    undefined
  );

var i18n = require('roddeh-i18n');
var script$3 = Vue.extend({
    props: {
        searchData: {}
    },
    data: function () {
        return {
            search: ''
        };
    },
    methods: {
        closeSearch: function () {
            this.$emit('closeSearch');
        },
        openSearch: function () {
            this.$emit('openSearch');
        },
        onChange: function () {
            this.$emit('onChange', this.search);
        },
        choose: function (result) {
            this.$emit('choose', result);
        }
    },
    computed: {
        placeholder: function () {
            return i18n('Ingredient name');
        }
    }
});

/* script */
var __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"autocomplete"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"searchBar",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":(_vm.search)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.search=$event.target.value;},_vm.onChange],"blur":_vm.closeSearch,"focus":_vm.openSearch}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(this.searchData.isOpen),expression:"this.searchData.isOpen"}],staticClass:"autocomplete-results"},_vm._l((_vm.searchData.results),function(result,i){return _c('li',{key:i,staticClass:"autocomplete-result",on:{"mousedown":function($event){return _vm.choose(result)}}},[_vm._v(_vm._s(result.name))])}),0)])])};
var __vue_staticRenderFns__$3 = [];

  /* style */
  var __vue_inject_styles__$3 = function (inject) {
    if (!inject) { return }
    inject("data-v-04ee1e08_0", { source: "input.searchBar[data-v-04ee1e08]{width:100%;margin:20px auto 0 auto;border:1px solid #143616;font-size:1.5em;padding:10px 3%;box-sizing:border-box}.autocomplete[data-v-04ee1e08]{width:50%;position:relative;margin:0 auto}.autocomplete-results[data-v-04ee1e08]{overflow-y:scroll;background-color:#fff;position:absolute;top:100%;z-index:100;left:0;right:0;padding:0;margin:0;border:1px solid #eee;max-height:1000px}.autocomplete-result[data-v-04ee1e08]{list-style:none;text-align:left;padding:8px 10px;cursor:pointer;margin-bottom:0}.autocomplete-result[data-v-04ee1e08]:hover{background-color:#143616;color:#fff}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$3 = "data-v-04ee1e08";
  /* module identifier */
  var __vue_module_identifier__$3 = undefined;
  /* functional template */
  var __vue_is_functional_template__$3 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    createInjector,
    undefined,
    undefined
  );

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var isBuffer = function isBuffer(arg) {
  return arg instanceof Buffer;
};

var inherits_browser = createCommonjsModule(function (module) {
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  };
}
});

var inherits = createCommonjsModule(function (module) {
try {
  var util$1 = util;
  if (typeof util$1.inherits !== 'function') { throw ''; }
  module.exports = util$1.inherits;
} catch (e) {
  module.exports = inherits_browser;
}
});

var util = createCommonjsModule(function (module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  var arguments$1 = arguments;

  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments$1[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') { return '%'; }
    if (i >= len) { return x; }
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    { debugEnviron = process.env.NODE_DEBUG || ''; }
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) { ctx.depth = arguments[2]; }
  if (arguments.length >= 4) { ctx.colors = arguments[3]; }
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) { ctx.showHidden = false; }
  if (isUndefined(ctx.depth)) { ctx.depth = 2; }
  if (isUndefined(ctx.colors)) { ctx.colors = false; }
  if (isUndefined(ctx.customInspect)) { ctx.customInspect = true; }
  if (ctx.colors) { ctx.stylize = stylizeWithColor; }
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    { return ctx.stylize('undefined', 'undefined'); }
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    { return ctx.stylize('' + value, 'number'); }
  if (isBoolean(value))
    { return ctx.stylize('' + value, 'boolean'); }
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    { return ctx.stylize('null', 'null'); }
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var length = output.reduce(function(prev, cur) {
    if (cur.indexOf('\n') >= 0) ;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = inherits;

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) { return origin; }

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    { throw new TypeError('The "original" argument must be of type Function'); }

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var arguments$1 = arguments;

    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments$1[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) { Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  }); }
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
};

exports.promisify.custom = kCustomPromisifiedSymbol;

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var arguments$1 = arguments;

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments$1[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret); },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb); });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;
});
var util_1 = util.format;
var util_2 = util.deprecate;
var util_3 = util.debuglog;
var util_4 = util.inspect;
var util_5 = util.isArray;
var util_6 = util.isBoolean;
var util_7 = util.isNull;
var util_8 = util.isNullOrUndefined;
var util_9 = util.isNumber;
var util_10 = util.isString;
var util_11 = util.isSymbol;
var util_12 = util.isUndefined;
var util_13 = util.isRegExp;
var util_14 = util.isObject;
var util_15 = util.isDate;
var util_16 = util.isError;
var util_17 = util.isFunction;
var util_18 = util.isPrimitive;
var util_19 = util.isBuffer;
var util_20 = util.log;
var util_21 = util.inherits;
var util_22 = util._extend;
var util_23 = util.promisify;
var util_24 = util.callbackify;

var i18n$1 = require('roddeh-i18n');
Vue.use(VueScrollTo);
var script$4 = Vue.extend({
    components: {
        IngredientDetails: __vue_component__$1,
        LettersMenu: __vue_component__$2,
        SearchBar: __vue_component__$3
    },
    data: function () {
        return {
            listLimit: 15,
            searchFixed: false,
            searchWrapTop: 0,
            chosenIngredient: {
                name: '',
                origin: '',
                description: '',
                origin_normal: '',
                creation_time: '',
                update_time: '',
                "class": ''
            },
            results: [],
            ingredients: [],
            fiteredIngredients: [],
            lettersRollArray: [],
            searchData: {
                isOpen: false,
                results: []
            }
        };
    },
    methods: {
        isMoreIngredients: function (key) {
            return (this.stack[key].length > this.listLimit);
        },
        changeUnroll: function (key) {
            this.lettersRollArray[key] = !this.lettersRollArray[key];
            this.goToLetter(key);
        },
        closeSearch: function () {
            this.searchData.isOpen = false;
        },
        openSearch: function () {
            this.searchData.isOpen = true;
        },
        limitList: function (list, key) {
            // Jeśli unroll jest false limitujemy listę
            if (!this.lettersRollArray[key]) {
                return list.slice(0, this.listLimit);
            }
            else {
                return list;
            }
        },
        onChange: function (search) {
            this.searchData.isOpen = true;
            this.filterResults(search);
        },
        filterResults: function (search) {
            this.results = this.ingredients.filter(function (item) { return item.name.toLowerCase().indexOf(search.toLowerCase()) > -1; });
            if (util_5(this.results) && !this.results.length) {
                this.results = [{ name: i18n$1('No hints found'),
                        origin: '',
                        description: '',
                        origin_normal: '',
                        creation_time: '',
                        update_time: ''
                    }];
                this.fiteredIngredients = this.ingredients;
            }
            else {
                this.fiteredIngredients = this.results;
            }
            this.searchData.results = this.results;
        },
        choose: function (ingredient) {
            this.searchData.isOpen = false;
            // TODO lepsze sprawdzanie
            if (i18n$1('No hints found') !== ingredient.name) {
                var chosenIngredient = {
                    name: ingredient.name,
                    origin: ingredient.origin,
                    origin_normal: ingredient.origin_normal,
                    description: ingredient.description,
                    creation_time: ingredient.creation_time,
                    update_time: ingredient.update_time,
                    "class": this.getOriginColor(ingredient.origin)
                };
                this.chosenIngredient = chosenIngredient;
                this.scrollToElement('#ingredient-details-pointer', 1000, -150);
            }
        },
        goToLetter: function (letter) {
            this.searchData.isOpen = false;
            this.scrollToElement('#letter-' + letter, 500, -120);
        },
        getOriginColor: function (origin) {
            if (origin === 'natural') {
                return 'highlightNatural';
            }
            else {
                return '';
            }
        },
        setIngredients: function (ingredients) {
            this.ingredients = ingredients;
            this.fiteredIngredients = ingredients;
            this.lettersRollArray = this.createLettersRollArray(ingredients);
        },
        handleScroll: function () {
            var element = document.querySelector('.search-wrap');
            if (null !== element) {
                if (0 === this.searchWrapTop) {
                    this.searchWrapTop = element.offsetTop;
                }
                this.searchFixed = window.scrollY > this.searchWrapTop;
            }
        },
        scrollToElement: function (selector, timeout, offset) {
            if (timeout === void 0) { timeout = 0; }
            if (offset === void 0) { offset = 0; }
            var element = document.querySelector(selector);
            if (null !== element) {
                VueScrollTo.scrollTo(element, timeout, { offset: offset });
            }
        },
        createLettersRollArray: function (ingredientList) {
            var result = {};
            if (Array.isArray(ingredientList)) {
                ingredientList.forEach(function (element) {
                    var key = element.name[0].toUpperCase();
                    if (!Array.isArray(result[key])) {
                        result[key] = false;
                    }
                });
            }
            return result;
        },
        showMoreText: function (key) {
            if (this.lettersRollArray[key]) {
                return i18n$1('Show less') + ' &laquo;';
            }
            else {
                return i18n$1('Show more') + ' &raquo;';
            }
        }
    },
    created: function () {
        window.addEventListener('scroll', this.handleScroll);
    },
    computed: {
        isSearchWrapFixed: function () {
            return this.searchFixed ? 'fixed' : '';
        },
        ingredientComputed: function () {
            return this.setIngredients(ApiService.ingredients);
        },
        stack: function () {
            var result = {};
            if (Array.isArray(this.fiteredIngredients)) {
                this.fiteredIngredients.forEach(function (element) {
                    var key = element.name[0].toUpperCase();
                    if (Array.isArray(result[key])) {
                        result[key].push(element);
                    }
                    else {
                        result[key] = [element];
                    }
                });
            }
            return result;
        }
    }
});

/* script */
var __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.ingredientComputed},[_c('letters-menu',{attrs:{"stack":_vm.stack},on:{"goToLetter":function($event){return _vm.goToLetter($event)}}}),_vm._v(" "),_c('div',{staticClass:"search-wrap",class:_vm.isSearchWrapFixed},[_c('search-bar',{attrs:{"searchData":_vm.searchData},on:{"onChange":function($event){return _vm.onChange($event)},"choose":function($event){return _vm.choose($event)},"closeSearch":_vm.closeSearch,"openSearch":_vm.openSearch}})],1),_vm._v(" "),_c('div',[_c('ingredient-details',{attrs:{"chosenIngredient":_vm.chosenIngredient}}),_vm._v(" "),_vm._l((_vm.stack),function(stackElement,key){return _c('div',{key:key},[_c('a',{attrs:{"name":'letter-'+key,"id":'letter-'+key}}),_vm._v(" "),_c('h2',{staticClass:"letter"},[_vm._v(_vm._s(key))]),_vm._v(" "),(stackElement)?_c('ul',{staticClass:"ingredientList"},_vm._l((_vm.limitList(stackElement, key)),function(ingredient){return _c('li',{key:ingredient.id,staticClass:"inredientElement",class:_vm.getOriginColor(ingredient.origin),on:{"click":function($event){return _vm.choose(ingredient)}}},[_c('span',{staticClass:"ingredientElementSpan"},[_vm._v(_vm._s(ingredient.name))])])}),0):_vm._e(),_vm._v(" "),(_vm.isMoreIngredients(key))?_c('div',{staticClass:"showMoreButton",domProps:{"innerHTML":_vm._s(_vm.showMoreText(key))},on:{"click":function($event){return _vm.changeUnroll(key)}}}):_vm._e()])})],2)],1)};
var __vue_staticRenderFns__$4 = [];

  /* style */
  var __vue_inject_styles__$4 = function (inject) {
    if (!inject) { return }
    inject("data-v-7f38d1ce_0", { source: "h2.letter[data-v-7f38d1ce]{text-transform:uppercase;font-size:2em;text-align:left;font-weight:700;padding:0 0 .4em;margin:.7em 0;border-bottom:1px solid rgba(0,0,0,.8)}hr[data-v-7f38d1ce]{margin:5px auto 10px}ul.ingredientList[data-v-7f38d1ce]{list-style:none;text-align:left;column-count:3;font-size:1.1em}ul.ingredientList>li[data-v-7f38d1ce]{margin-bottom:.4em;word-break:break-word;min-height:30px;display:inline-block;width:100%;break-inside:avoid}li.inredientElement[data-v-7f38d1ce]{cursor:pointer}.search-wrap[data-v-7f38d1ce]{position:sticky}.search-wrap.fixed[data-v-7f38d1ce]{background-color:#fff;top:54px;left:0;right:0;z-index:90}.showMoreButton[data-v-7f38d1ce]{cursor:pointer}@media screen and (max-width:960px){.search-wrap.fixed[data-v-7f38d1ce]{top:54px}ul.ingredientList[data-v-7f38d1ce]{column-count:1}}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$4 = "data-v-7f38d1ce";
  /* module identifier */
  var __vue_module_identifier__$4 = undefined;
  /* functional template */
  var __vue_is_functional_template__$4 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$4 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    createInjector,
    undefined,
    undefined
  );

var i18n$2 = require('roddeh-i18n');
var script$5 = Vue.extend({
    name: 'lexicon',
    filters: {
        'i18n': function (value) {
            return i18n$2(value);
        }
    },
    components: {
        IngredientList: __vue_component__$4,
        LoaderRing: __vue_component__
    },
    computed: {
        ingredientsLoaded: function () {
            return ApiService.ingredientsLoaded;
        }
    },
    beforeMount: function () {
        ApiService.initialize();
    }
});

/* script */
var __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lexicon"}},[_c('h1',[_vm._v(_vm._s(_vm._f("i18n")('Lexicon Ingredients')))]),_vm._v(" "),(!_vm.ingredientsLoaded)?_c('div',{staticClass:"component-loading"},[_c('loader-ring',{attrs:{"size":"64","color":"rgb(139, 150, 32)"}}),_vm._v(" \n    "),_c('span',[_vm._v(_vm._s(_vm._f("i18n")('Loading'))+"...")])],1):_vm._e(),_vm._v(" "),_c('IngredientList')],1)};
var __vue_staticRenderFns__$5 = [];

  /* style */
  var __vue_inject_styles__$5 = function (inject) {
    if (!inject) { return }
    inject("data-v-2d21b193_0", { source: "body{font-family:'Open Sans',sans-serif;font-size:12px}#lexicon{box-sizing:border-box;margin:0 auto;max-width:1248px;background-color:#fff;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#60472e;padding:60px 5%}.highlightNatural{color:#8b9620}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$5 = undefined;
  /* module identifier */
  var __vue_module_identifier__$5 = undefined;
  /* functional template */
  var __vue_is_functional_template__$5 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$5 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    createInjector,
    undefined,
    undefined
  );

export { __vue_component__$5 as App };
